var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinimumValue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M8.613 12.37a6 6 0 0 1 .18.408l.087-.212q.045-.105.096-.202l1.284-2.403a.4.4 0 0 1 .048-.072.2.2 0 0 1 .057-.039.3.3 0 0 1 .072-.015q.039-.003.093-.003h.609v4.338h-.711v-2.802l.003-.17.015-.19-1.311 2.46a.36.36 0 0 1-.117.133.3.3 0 0 1-.168.044h-.111a.3.3 0 0 1-.168-.044.36.36 0 0 1-.117-.133L7.125 11q.012.099.015.195.006.094.006.174v2.803h-.711v-4.34h.609q.054 0 .093.003a.2.2 0 0 1 .069.015.2.2 0 0 1 .06.04.3.3 0 0 1 .051.071l1.296 2.41Zm4.309 1.8h-.81V9.832h.81zm1.401-4.338q.054 0 .09.006a.2.2 0 0 1 .063.018.2.2 0 0 1 .057.04 1 1 0 0 1 .06.065l2.277 2.902a4 4 0 0 1-.018-.204l-.003-.19V9.832h.71v4.338h-.416a.4.4 0 0 1-.16-.03.35.35 0 0 1-.122-.107l-2.268-2.89q.009.096.012.192.006.095.006.171v2.665H13.9V9.832z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinimumValue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/minimum-value.263f1768.svg";